<template>
  <div class="module-content-box" v-if="activeModuleDataMapper">
<!--    <template v-if="activeModules === 'reports'">-->
<!--      <ModulesNavigationBox :nb-modules="activeModule"-->
<!--                            :nb-navigation-name="activeModules"-->
<!--                            :nb-minor-name="activeModules"-->
<!--                            :nb-minor-active="minorActive"></ModulesNavigationBox>-->
<!--    </template>-->
    <div class="filter-search-box flex-center">
      <FilterBox class="filter"
                 :fb-filters="activeModuleData.filters"
                 :fb-types="activeModuleData.filterTypes"
                 :fb-active-filters="activeModuleData.activeFilters"
                 :fb-translations="activeModuleData.filterDisplayName"/>
      <IconSearchBox class="icon-search"></IconSearchBox>
    </div>
    <div class="content-sidebar-box"
         :style="[activeModules === 'reports'
         ? {height: 'calc(100% - 60px - 50px - 56px)'}
         : {height: 'calc(100% - 50px - 56px)'}]">
      <ContentBox class="content"
                  :content-data="activeModuleData.data"
                  :content-titles="activeModuleData.titles"
                  :content-sums="activeModuleData.sums"
                  :content-pagination="activeModuleData.pagination"
                  :content-type="'main'"
                  :style="[
                  Object.prototype.hasOwnProperty.call(
                    activeModule,
                    'sideBar',
                    )
                    ? {width: 'calc(100% - 33.334% - 6px)'}
                    : {width: '100%'}]"/>
      <template v-if="Object.prototype.hasOwnProperty.call(
        activeModule,
        'sideBar',
        ) && sidebarDataMapper">
        <SidebarBox class="sidebar"
                    :sb-type="activeModule.id"
                    :sb-data="sidebarData"
                    :sb-header-data="activeModuleData.data[selectedRow]"
                    :sb-header-titles="activeModuleData.titles">
        </SidebarBox>
      </template>
    </div>
    <div class="module-content-pagination">
      <PaginationFooterBox
        v-on:update-rows-per-page="setRowsPerPage"
        v-on:pagination-active-page="fetchData"
        :pfb-pagination="activeModuleData.pagination"
        :pfb-style="paginationStyle"
        :pfb-rows-per-page="paginationsRowsPerPage"
        :pfb-rows-per-page-active="rowsPerPage"
        :active-page="activePage"
        :pfb-sidebar="false"></PaginationFooterBox>
    </div>
    <CustomOfferSelection
      v-if="customOfferSelectionActive"></CustomOfferSelection>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import CustomOfferSelection from '@/components/CustomOfferSelection';
import FilterBox from '../components/FilterBox';
// import ModulesNavigationBox from '../components/ModulesNavigationBox';
import ContentBox from '../components/ContentBox';
import SidebarBox from '../components/SidebarBox';
import PaginationFooterBox from '../components/PaginationFooterBox';
import IconSearchBox from '../components/IconSearchBox';

export default {
  name: 'ModuleContentBox',
  data() {
    return {
      paginationStyle: {
        backgroundColor: '#e8ecee',
      },
      paginationsRowsPerPage: ['5', '10', '25', '50', '100'],
      sidebarMapper: {
        tickets: {
          header: ['match_name', 'match_datetime'],
          contentTable: true,
          comment: true,
        },
        events: {
          header: [],
          contentTable: true,
          comment: false,
        },
        results: {
          header: ['name', 'result', 'bonus_ball'],
          contentTable: true,
          comment: false,
        },
      },
    };
  },
  components: {
    CustomOfferSelection,
    IconSearchBox,
    PaginationFooterBox,
    SidebarBox,
    ContentBox,
    FilterBox,
    // ModulesNavigationBox,
  },
  computed: {
    ...mapGetters([
      'minorActive',
      'mainView',
      'activeModules',
      'modules',
      'activeModule',
      'activeModuleData',
      'activeModuleDataMapper',
      'rowsPerPage',
      'sidebarData',
      'sidebarDataMapper',
      'mainTableHeaderDropdownData',
      'sidebarTableHeaderDropdownData',
      'activeSort',
      'activeDirection',
      'activePage',
      'selectedRow',
      'customOfferSelectionActive',
    ]),
  },
  methods: {
    ...mapActions([
      'setActiveMinorModule',
      'setRowsPerPage',
      'fetchActiveModuleData',
      'setActivePaginationPage',
      'callCheckAxiosSource',
    ]),
    fetchData(page) {
      this.setActivePaginationPage(page);
      const sendData = {
        page,
      };
      if (this.activeDirection) {
        sendData.direction = this.activeDirection;
      }
      if (this.activeSort) {
        sendData.sort = this.activeSort;
      }
      this.callCheckAxiosSource();
      this.fetchActiveModuleData(sendData);
    },
  },
};
</script>

<style lang="scss" scoped>
  .module-content-box {
    height: calc(100% - 50px);
    padding: 10px 10px 0 10px;
    position: relative;
    .filter-search-box {
      .filter {
        width: 75%;
      }
      .icon-search {
        background-color: #e8ecee;
        height: 50px;
        width: 25%;
      }
    }
  }
  .content-sidebar-box {
    background-color: #e8ecee;
    display: flex;
    padding-top: 2px;
  }
  .sidebar {
    margin-left: 6px;
    overflow: auto;
    width: 33.334%;
  }
  .module-content-pagination {
    height: 56px;
  }
</style>
